module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-screen"
  }, [_c('div', {
    staticClass: "loading-container"
  }, [_c('ProgressBar', {
    attrs: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "loading-sent"
  }, [_vm._v("\n      " + _vm._s(_vm.pickedSentance) + "\n    ")])], 1), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "loading-logo",
    attrs: {
      "src": ("/static/img/" + _vm.logoSvg)
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.appVersion) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07af3fae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Loading.vue
// module id = 593
// module chunks = 9